import { createApi, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react';

import { LoginRequest } from '@app/store/slices/auth/authTypes';
import { baseQueryWithReauth } from '@app/store/utils/baseQueryWithReauth';
import { ApiResponse } from '@app/store/utils/common';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    login: builder.mutation<ApiResponse<{ accessToken?: string }>, LoginRequest>({
      query: (data) => ({
        url: '/auth/login',
        method: 'POST',
        body: data,
      }),
      transformResponse: (
        response: ApiResponse<{ ok: boolean }>,
        meta: FetchBaseQueryMeta | undefined
      ): ApiResponse<{ accessToken?: string }> => {
        const authHeader = meta?.response?.headers.get('authorization');

        return {
          ok: response.ok,
          data: {
            accessToken: authHeader?.replace('Bearer ', ''),
          },
        };
      },
    }),
    refresh: builder.mutation<ApiResponse<{ accessToken?: string }>, void>({
      query: (data) => ({
        url: '/auth/refresh',
        method: 'POST',
        body: data,
      }),
      transformResponse: (
        response: ApiResponse<{ ok: boolean }>,
        meta: FetchBaseQueryMeta | undefined
      ): ApiResponse<{ accessToken?: string }> => {
        const authHeader = meta?.response?.headers.get('authorization');

        return {
          ok: response.ok,
          data: {
            accessToken: authHeader?.replace('Bearer ', ''),
          },
        };
      },
    }),
    telegramLogin: builder.mutation<ApiResponse<{ accessToken?: string }>, { initData: string }>({
      query: (data) => ({
        url: '/auth/telegram-login',
        method: 'POST',
        body: data,
      }),
      transformResponse: (
        response: ApiResponse<{ ok: boolean }>,
        meta: FetchBaseQueryMeta | undefined
      ): ApiResponse<{ accessToken?: string }> => {
        const authHeader = meta?.response?.headers.get('authorization');

        return {
          ok: response.ok,
          data: {
            accessToken: authHeader?.replace('Bearer ', ''),
          },
        };
      },
    }),
    logout: builder.mutation<void, void>({
      query: (data) => ({
        url: '/auth/logout',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const { useLoginMutation, useRefreshMutation, useLogoutMutation, useTelegramLoginMutation } =
  authApi;
